/**
 * PD-17109 — where a competitor on a job stands (sales relationships plan,
 * section 4; owner decisions 2026-10-16).
 *
 * The STATUSES are a tenant-editable catalog list (catalog_value, type
 * `competitor_engagement_status`); every status value maps to one of the small
 * fixed OUTCOMES below, the way an opportunity stage maps to open / won /
 * lost, so later actions key off the outcome and never off a label a tenant
 * may rename.
 */

/**
 * Where a competitor stands on a job, whatever the tenant calls it:
 * - quoting: pricing it against us, not decided;
 * - supplying: delivering material on it;
 * - won: got the business;
 * - lost: did not get it.
 */
export const COMPETITOR_ENGAGEMENT_STATUS_OUTCOMES = ['quoting', 'supplying', 'won', 'lost'] as const;
export type CompetitorEngagementStatusOutcome = (typeof COMPETITOR_ENGAGEMENT_STATUS_OUTCOMES)[number];

export const COMPETITOR_ENGAGEMENT_STATUS_OUTCOME_LABELS: Readonly<Record<CompetitorEngagementStatusOutcome, string>> = {
	quoting: 'Quoting',
	supplying: 'Supplying',
	won: 'Won',
	lost: 'Lost',
};

/** A tenant's starting status list: each value's name and the outcome it means. */
export interface DefaultStatusValueModel {
	name: string;
	outcome: string;
}

/** Seeded per tenant; admins rename, reorder or add in Settings → Catalog Values. */
export const DEFAULT_COMPETITOR_ENGAGEMENT_STATUSES: ReadonlyArray<DefaultStatusValueModel> = [
	{ name: 'Quoting', outcome: 'quoting' },
	{ name: 'Supplying', outcome: 'supplying' },
	{ name: 'Won', outcome: 'won' },
	{ name: 'Lost', outcome: 'lost' },
];
